export enum BoardGameStatus {
	COMING_SOON = "COMING_SOON",
	PUBLISHED = "PUBLISHED",
}

export const BoardGameStatusOptions = [
	{ value: BoardGameStatus.COMING_SOON, label: "به زودی" },
	{ value: BoardGameStatus.PUBLISHED, label: "توزیع شده" },
] as const;
